/**
 * frontend.js
 *
 * JavaScript für das Frontend des UD Blank Blocks.
 * Diese Datei wird nur auf der Website (nicht im Editor) geladen.
 *
 * Hinweis:
 * Hier können zukünftig Interaktionen, Animationen oder API-Aufrufe
 * für den Block ergänzt werden.
 */

document.addEventListener('DOMContentLoaded', () => {

    const navs = document.querySelectorAll('[data-ud-overlay-navigation]');

    navs.forEach(nav => {

        const toggleButton = nav.querySelector('.ud-overlay-navigation__toggle');
        const closeButton  = nav.querySelector('.ud-overlay-navigation__close');
        const backdrop     = nav.querySelector('.ud-overlay-navigation__backdrop');
        const panel        = nav.querySelector('.ud-overlay-navigation__panel');

        const closeOnLinkClick = nav.dataset.closeOnLinkClick === 'true';
        const lockBodyScroll   = nav.dataset.lockBodyScroll === 'true';

        if (!toggleButton || !backdrop || !panel) return;

        const open = () => {
            nav.classList.add('is-open');
            toggleButton.setAttribute('aria-expanded', 'true');

            if (lockBodyScroll) {
                document.body.classList.add('ud-overlay-navigation-open');
            }
        };

        const close = () => {
            nav.classList.remove('is-open');
            toggleButton.setAttribute('aria-expanded', 'false');

            if (lockBodyScroll) {
                document.body.classList.remove('ud-overlay-navigation-open');
            }
        };

        const isOpen = () => nav.classList.contains('is-open');

        // Toggle Button
        toggleButton.addEventListener('click', () => {
            isOpen() ? close() : open();
        });

        // Close Button
        if (closeButton) {
            closeButton.addEventListener('click', close);
        }

        // Click outside (Backdrop)
        backdrop.addEventListener('click', (e) => {
            if (!panel.contains(e.target)) {
                close();
            }
        });

        // ESC Key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isOpen()) {
                close();
            }
        });

        // Optional: Close on link click
        if (closeOnLinkClick) {
            nav.querySelectorAll('a').forEach(link => {
                link.addEventListener('click', () => {
                    close();
                });
            });
        }

    });

});